export const filter = {
    id : '',
    name : '',
    room_number: '',
    created_at: "",
    updated_at: ''
};
